import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ae72161"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "local-work-experience" }
const _hoisted_2 = {
  key: 0,
  class: "experience-loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading work experience...", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "experience-error"
}
const _hoisted_7 = { class: "error-content" }
const _hoisted_8 = {
  key: 2,
  class: "tech-legend"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<h6 class=\"legend-title\" data-v-0ae72161>Technology Categories</h6><div class=\"legend-items\" data-v-0ae72161><div class=\"legend-item\" data-v-0ae72161><span class=\"legend-tag tech-language\" data-v-0ae72161>Languages</span></div><div class=\"legend-item\" data-v-0ae72161><span class=\"legend-tag tech-framework\" data-v-0ae72161>Frameworks</span></div><div class=\"legend-item\" data-v-0ae72161><span class=\"legend-tag tech-infrastructure\" data-v-0ae72161>Infrastructure</span></div><div class=\"legend-item\" data-v-0ae72161><span class=\"legend-tag tech-database\" data-v-0ae72161>Databases</span></div><div class=\"legend-item\" data-v-0ae72161><span class=\"legend-tag tech-security\" data-v-0ae72161>Security</span></div><div class=\"legend-item\" data-v-0ae72161><span class=\"legend-tag tech-blockchain\" data-v-0ae72161>Blockchain</span></div><div class=\"legend-item\" data-v-0ae72161><span class=\"legend-tag tech-protocol\" data-v-0ae72161>Protocols</span></div><div class=\"legend-item\" data-v-0ae72161><span class=\"legend-tag tech-interop\" data-v-0ae72161>Interop</span></div><div class=\"legend-item\" data-v-0ae72161><span class=\"legend-tag tech-other\" data-v-0ae72161>Other</span></div></div>", 2)
const _hoisted_11 = [
  _hoisted_9
]
const _hoisted_12 = { class: "company-header" }
const _hoisted_13 = {
  key: 0,
  class: "company-logo"
}
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "company-info" }
const _hoisted_16 = { class: "company-name" }
const _hoisted_17 = { class: "company-meta" }
const _hoisted_18 = { class: "company-duration" }
const _hoisted_19 = { class: "company-location" }
const _hoisted_20 = { class: "positions-container" }
const _hoisted_21 = { class: "position-header" }
const _hoisted_22 = { class: "position-title" }
const _hoisted_23 = { class: "position-date" }
const _hoisted_24 = { class: "description-section" }
const _hoisted_25 = { class: "description-content" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "technologies-section"
}
const _hoisted_30 = { class: "tech-tags" }
const _hoisted_31 = {
  key: 1,
  class: "highlights-section"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "highlights-title" }, "Key Achievements", -1))
const _hoisted_33 = { class: "highlights-list" }
const _hoisted_34 = {
  key: 3,
  class: "experience-branding"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Professional Experience", -1))
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ion_icon, {
                name: "briefcase-outline",
                class: "error-icon"
              }),
              _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11)),
    _createElementVNode("div", {
      class: "experience-grid",
      style: _normalizeStyle({ '--columns': _ctx.gridColumns })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedCompanies, (company, cIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: cIndex,
          class: "company-card"
        }, [
          _createElementVNode("div", _hoisted_12, [
            (company.logo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("img", {
                    src: company.logo,
                    alt: company.name + ' logo'
                  }, null, 8, _hoisted_14)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h3", _hoisted_16, _toDisplayString(company.name), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(company.totalDuration), 1),
                _createElementVNode("span", _hoisted_19, _toDisplayString(company.location), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(company.positions, (position, pIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: pIndex,
                class: "position-card"
              }, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("h4", _hoisted_22, _toDisplayString(position.title), 1),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.formatDateRange(position.startDate, position.endDate)), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    (!position.expanded && _ctx.shouldShowExpand(position.description))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.truncateWithEllipsis(position.description)), 1))
                      : (position.expanded || !_ctx.shouldShowExpand(position.description))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatDescription(position.description), (paragraph, pIndex) => {
                              return (_openBlock(), _createElementBlock("p", { key: pIndex }, _toDisplayString(paragraph), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                  ]),
                  (_ctx.shouldShowExpand(position.description))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.togglePositionExpand(position)),
                        class: "expand-button"
                      }, _toDisplayString(position.expanded ? 'Show Less' : 'Show More'), 9, _hoisted_28))
                    : _createCommentVNode("", true)
                ]),
                (position.technologies && position.technologies.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.technologies, (tech) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: tech,
                            class: _normalizeClass(["tech-tag", _ctx.getTechCategory(tech)])
                          }, _toDisplayString(tech), 3))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (position.highlights && position.highlights.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("ul", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.highlights, (highlight) => {
                          return (_openBlock(), _createElementBlock("li", { key: highlight }, _toDisplayString(highlight), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ], 4),
    (_ctx.showBranding)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
      : _createCommentVNode("", true)
  ]))
}